// extracted by mini-css-extract-plugin
export default {"contact":"contact_contact__bHJ-r","title":"contact_title__QipBl","fields":"contact_fields__e1iWH","field":"contact_field__weROh","buttons":"contact_buttons__z9jPa"};